export const content = `If your session keeps freezing or you're having trouble joining it, there are a few things you can try doing:

- Click **Join** twice to make sure you’ve tried to join the session.
- Sign out then sign back in to BetterHelp.
- Restart your device.
- If your internet connection is weak, try joining the session without video.
- Make sure you have at least 3G internet speed.
- Check your video and microphone permissions in your browser. Here are the instructions for some common browsers:
  - [Chrome](https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop&hl=en&oco=1)
  - [Safari (Mac)](https://support.apple.com/guide/safari/websites-ibrwe2159f50/mac)
  - [Firefox](https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions)
  - [Edge](https://support.microsoft.com/en-us/windows/windows-10-camera-microphone-and-privacy-a83257bc-e990-d54a-d212-b5e41beba857)

If you continue to have issues, check that your device meets the [technical requirements to use BetterHelp](/support/articles/technical-requirements) or contact our support team.
`;
